import {Inject, Pipe, PipeTransform} from '@angular/core';
import {APP_CONFIG, AppConfig} from "../../../config/app.config";

@Pipe({
  name: 'durationPipe',
  standalone: true,
})
export class DurationPipe implements PipeTransform {

  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig,) {
  }

  private translates: any = this.appConfig.translates.aviaListing;
  transform(totalMinutes: number): string {
    if (totalMinutes == null || isNaN(totalMinutes)) {
      return '';
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    let result = '';
    if (hours) {
      result += `${hours}${this.translates.duration.shortHour}`;
    }
    if (minutes) {
      result += (hours ? ' ' : '') + `${minutes}${this.translates.duration.shortMinutes}`;
    }

    return result || '';
  }
}
